import React from "react";
import "./role.css";

function role() {
  return (
    <div className="permission-user-page">

      {/* HEADER */}
      <div className="permission-user-header">

        <div>
          <h2>Phân quyền theo người dùng</h2>

          <div className="permission-user-breadcrumb">
            Trang chủ / Quản trị hệ thống /
            <span> Phân quyền theo người dùng</span>
          </div>
        </div>

        <button className="permission-guide-btn">
          <i className="fa-regular fa-circle-question"></i>
          Hướng dẫn
        </button>

      </div>

      {/* FILTER */}
      <div className="permission-filter-card">

        <div className="permission-filter-grid">

          <div className="permission-filter-item">
            <label>Tìm kiếm người dùng</label>

            <div className="permission-search-box">
              <input
                type="text"
                placeholder="Nhập tên, tài khoản, email, số điện thoại..."
              />

              <i className="fa-solid fa-magnifying-glass"></i>
            </div>
          </div>

          <div className="permission-filter-item">
            <label>Nhóm người dùng</label>

            <select>
              <option>-- Tất cả nhóm --</option>
            </select>
          </div>

          <div className="permission-filter-item">
            <label>Trạng thái</label>

            <select>
              <option>-- Tất cả trạng thái --</option>
            </select>
          </div>

          <div className="permission-filter-item">
            <label>Đơn vị</label>

            <select>
              <option>-- Tất cả đơn vị --</option>
            </select>
          </div>

          <div className="permission-filter-btn-group">

            <button className="permission-reset-btn">
              <i className="fa-solid fa-rotate-left"></i>
              Đặt lại
            </button>

            <button className="permission-search-btn">
              <i className="fa-solid fa-magnifying-glass"></i>
              Tìm kiếm
            </button>

          </div>

        </div>

      </div>

      {/* CONTENT */}
      <div className="permission-main-content">

        {/* LEFT */}
        <div className="permission-user-list-card">

          <div className="permission-card-header">
            <h3>Danh sách người dùng</h3>

            <button>
              <i className="fa-solid fa-rotate"></i>
            </button>
          </div>

          {/* SEARCH */}
          <div className="permission-list-search">
            <input
              type="text"
              placeholder="Tìm kiếm trong danh sách..."
            />

            <i className="fa-solid fa-magnifying-glass"></i>
          </div>

          {/* TABLE */}
          <div className="permission-user-table-wrapper">

            <table className="permission-user-table">

              <thead>
                <tr>
                  <th>STT</th>
                  <th>Họ và tên</th>
                  <th>Tài khoản</th>
                  <th>Nhóm</th>
                  <th>Trạng thái</th>
                </tr>
              </thead>

              <tbody>

                <tr>
                  <td>1</td>
                  <td>Nguyễn Văn An</td>
                  <td>nguyenvanan</td>
                  <td>Cán bộ nghiệp vụ</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr className="active-row">
                  <td>2</td>
                  <td>Trần Thị Bình</td>
                  <td>tranthibinh</td>
                  <td>Cán bộ nghiệp vụ</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>3</td>
                  <td>Lê Văn Cường</td>
                  <td>levancuong</td>
                  <td>Lãnh đạo</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>4</td>
                  <td>Phạm Minh Đức</td>
                  <td>phamminhduc</td>
                  <td>Cán bộ nghiệp vụ</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>5</td>
                  <td>Hoàng Thị Mai</td>
                  <td>hoangthimai</td>
                  <td>Doanh nghiệp</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>6</td>
                  <td>Đặng Quốc Hùng</td>
                  <td>dangquochung</td>
                  <td>Quản trị hệ thống</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>7</td>
                  <td>Võ Thị Lan</td>
                  <td>vothilan</td>
                  <td>Cán bộ nghiệp vụ</td>

                  <td>
                    <span className="status lock">
                      Tạm khóa
                    </span>
                  </td>
                </tr>

              </tbody>

            </table>

          </div>

          {/* PAGINATION */}
          <div className="permission-pagination">

            <div className="permission-page-left">
              Hiển thị

              <select>
                <option>10</option>
              </select>

              dòng
            </div>

            <div className="permission-page-number">
              <button>{"<<"}</button>
              <button className="active">1</button>
              <button>2</button>
              <button>3</button>
              <button>{">>"}</button>
            </div>

          </div>

        </div>

        {/* RIGHT */}
        <div className="permission-detail-card">

          {/* TOP */}
          <div className="permission-detail-top">

            <div>
              <h3>
                Thông tin người dùng:
                <span> Trần Thị Bình</span>
              </h3>
            </div>

            <button className="edit-user-btn">
              <i className="fa-regular fa-pen-to-square"></i>
              Sửa thông tin
            </button>

          </div>

          {/* USER INFO */}
          <div className="permission-user-info">

            <div className="permission-avatar">
              <i className="fa-solid fa-user"></i>
            </div>

            <div className="permission-info-grid">

              <div>
                <label>Tài khoản</label>
                <p>tranthibinh</p>
              </div>

              <div>
                <label>Nhóm người dùng</label>
                <p>Cán bộ nghiệp vụ</p>
              </div>

              <div>
                <label>Email</label>
                <p>tranthibinh@angiang.gov.vn</p>
              </div>

              <div>
                <label>Đơn vị</label>
                <p>Phòng Quản lý Công nghiệp</p>
              </div>

              <div>
                <label>Số điện thoại</label>
                <p>0909 234 567</p>
              </div>

              <div>
                <label>Trạng thái</label>

                <span className="status active">
                  Hoạt động
                </span>
              </div>

            </div>

          </div>

          {/* TAB */}
          <div className="permission-detail-tab">

            <button className="active">
              Phân quyền
            </button>

            <button>
              Lịch sử thay đổi
            </button>

          </div>

          {/* ACTION */}
          <div className="permission-action-top">

            <div className="permission-quick-action">

              <span>Chọn nhanh</span>

              <button>Toàn quyền</button>
              <button>Chọn tất cả</button>
              <button>Bỏ chọn tất cả</button>

            </div>

            <button className="save-permission-btn">
              <i className="fa-regular fa-floppy-disk"></i>
              Lưu phân quyền
            </button>

          </div>

          {/* TABLE */}
<div className="permission-matrix-wrapper">

  <table className="permission-matrix-table">

    <thead>

      <tr className="top-header-row">
        <th rowSpan="2" className="function-col">
          Chức năng
        </th>

        <th colSpan="7" className="permission-col">
          Quyền hạn
        </th>
      </tr>

      <tr>
        <th>Xem</th>
        <th>Thêm</th>
        <th>Sửa</th>
        <th>Xóa</th>
        <th>Xuất dữ liệu</th>
        <th>In</th>
        <th>Duyệt</th>
      </tr>

    </thead>

    <tbody>

      {/* DASHBOARD */}
      <tr className="main-row">
        <td className="group-cell">
          <i className="fas fa-caret-down table-arrow"></i>
          Dashboard
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Tổng quan
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
      </tr>

      {/* DOANH NGHIỆP */}
      <tr className="main-row">
        <td className="group-cell">
          <i className="fas fa-caret-down table-arrow"></i>
          Doanh nghiệp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Danh sách doanh nghiệp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Thêm doanh nghiệp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Cập nhật doanh nghiệp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Xóa doanh nghiệp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
      </tr>

      {/* BÁO CÁO */}
      <tr className="main-row">
        <td className="group-cell">
          <i className="fas fa-caret-down table-arrow"></i>
          Báo cáo
        </td>

        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td className="sub-row">
          Báo cáo tổng hợp
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
      </tr>

      <tr>
        <td className="sub-row">
          Báo cáo chi tiết
        </td>

        <td><input type="checkbox" defaultChecked /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
        <td><input type="checkbox" /></td>
      </tr>

      {/* KÊ KHAI */}
      <tr className="main-row collapsed-row">
        <td className="group-cell">
          <i className="fas fa-caret-right table-arrow"></i>
          Kê khai
        </td>

        <td colSpan="7"></td>
      </tr>

      {/* QUẢN LÝ DỮ LIỆU */}
      <tr className="main-row collapsed-row">
        <td className="group-cell">
          <i className="fas fa-caret-right table-arrow"></i>
          Quản lý dữ liệu
        </td>

        <td colSpan="7"></td>
      </tr>

    </tbody>

  </table>


</div>

          {/* NOTE */}
          <div className="permission-note">
<div className="permission-note-text">
      Ghi chú: Quyền được kế thừa từ nhóm sẽ được hiển thị màu xanh nhạt.
    </div>

            <div className="permission-note-item">
              <span className="blue"></span>
              Được phép
            </div>

            <div className="permission-note-item">
              <span className="gray"></span>
              Kế thừa
            </div>

            <div className="permission-note-item">
              <span className="white"></span>
              Không được phép
            </div>
          </div>

        </div>

      </div>

    </div>
  );
}

export default role;